import { AuthForms } from '@/components'
import { AppImages, React } from '@/app'
import { AuthModal } from './AuthModal'

const IMAGE_HEIGHT = 200

export const AboutJobModal = () => {
  return (
    <AuthModal name="aboutJob" image={AppImages.YourJob} centered={false} imageHeight={IMAGE_HEIGHT}>
      <AuthForms.AboutJobForm />
    </AuthModal>
  )
}
